/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Faq_Free_AInputs */

const en_price_page_faq_free_a = /** @type {(inputs: Price_Page_Faq_Free_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You start free, with 3 workouts and 3 meal scans. After that your own training and meal scans are 49 zł a month or 249 zł a year. Booking, anything a specialist gives you, food search and everything you have already logged stay free.`)
};

const pl_price_page_faq_free_a = /** @type {(inputs: Price_Page_Faq_Free_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaczynasz za darmo: 3 treningi i 3 skany posiłków. Potem własne treningi i skany kosztują 49 zł miesięcznie albo 249 zł rocznie. Rezerwacje, wszystko, co dostajesz od specjalisty, wyszukiwarka produktów i to, co już zapisano, zostają za darmo.`)
};

/**
* | output |
* | --- |
* | "You start free, with 3 workouts and 3 meal scans. After that your own training and meal scans are 49 zł a month or 249 zł a year. Booking, anything a special..." |
*
* @param {Price_Page_Faq_Free_AInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_faq_free_a = /** @type {((inputs?: Price_Page_Faq_Free_AInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Faq_Free_AInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_faq_free_a(inputs)
	return en_price_page_faq_free_a(inputs)
});